import { Component, EventEmitter, OnInit, Input, Output, ViewEncapsulation } from '@angular/core';
import { generalConditions, loadTagInstructionsFunc, loadTagInstructionsFuncPhase2 } from './rules-and-agreement-constants/rules-and-agreement-constants';
import { ViewportScroller } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-rules-agreement',
    templateUrl: './rules-agreement.component.html',
    styleUrls: ['./rules-agreement.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RulesAgreement implements OnInit {
  generalConditions: any[] = generalConditions;
  loadTagInstructions: string[]  = [];
  otherConditions: any[] = [];
  checkboxTotalCount: number = 0;
  checkboxRunningCount: number = 0;
  navLinks = [];

  @Input() forest: any;
  @Output('prev') prev: EventEmitter<any> = new EventEmitter();
  @Output('next') next: EventEmitter<any> = new EventEmitter();

  constructor( private readonly viewPortScroller: ViewportScroller, private readonly titleService: Title, ) {
    this.titleService.setTitle("USDA Forest Service E-Permits - Rules & Agreement")
  }

  ngOnInit() {
    this.loadTagInstructions =  this.getLoadTagInstructions();
    this.formatGeneralConditionsForLoadTags();
    this.viewPortScroller.scrollToPosition([0, 0]);
    this.otherConditions = this.forest.product.other_conditions ? this.forest.product.other_conditions : [];
    this.checkboxTotalCount = this.generalConditions.length + 1 + (this.otherConditions.length > 0 ? this.otherConditions.length : 0) + (this.forest.product.has_load_tags ? this.loadTagInstructions.length : 0);
    this.navLinks = [
      { id: 'generalConditions', name: 'General Conditions'},
      { id: 'otherConditions', name: 'Other Conditions'},
      ...(this.forest.product.has_load_tags ? [{ id: 'loadTagInstructions', name: 'Load Tag Instructions'}] : [] ),
      { id: 'emailCommunication', name: 'Email Communication'}
    ];
  }

  getLoadTagInstructions() {
    if (this.forest.product.alternate_load_tag_instructions) {
      return loadTagInstructionsFuncPhase2(this.forest.product.tags_per_uom, this.forest.product.unit_type.toLowerCase());
    } else {
      return loadTagInstructionsFunc(this.forest.product.tags_per_uom);
    }
  }

  formatGeneralConditionsForLoadTags() {
    this.generalConditions = this.generalConditions.map((gc) => {
      if (gc.includes('forest.product.has_load_tags')) {
        const loadTagsText = gc.substring(gc.indexOf('forest.product.has_load_tags') + 'forest.product.has_load_tags'.length + 1, gc.length);
        return this.forest.product.has_load_tags ? `${gc.substring(0, gc.indexOf('forest.product.has_load_tags'))} ${loadTagsText}` : gc.substring(0, gc.indexOf('forest.product.has_load_tags'));
      } else { return gc }
    })
  }

  callPrev() {
    this.prev.emit();
  }

  callNext() {
    this.next.emit();
  }

  checkedBox(event){
    if (event.target.checked) {
      this.checkboxRunningCount++;
    } else {
      this.checkboxRunningCount--;
    }
  }

  checkIfValid(){
    if (this.checkboxRunningCount === this.checkboxTotalCount) {
      return false
    } else {
      return true
    }
  }

  scroll(event: Event, elementId: string) {
    event.preventDefault();
    this.viewPortScroller.scrollToAnchor(elementId);
  }
}
